import { render, staticRenderFns } from "./RegisterRootCA.vue?vue&type=template&id=72933d20&"
import script from "./RegisterRootCA.vue?vue&type=script&lang=js&"
export * from "./RegisterRootCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports